import React from 'react';

const renderNode = (node) => {
  switch (node.type) {
    case 'text':
      let textFragments = node.text.split('\n').map((fragment, index) => (
        <React.Fragment key={index}>
          {fragment}
          {index < node.text.split('\n').length - 1 && <br />}
        </React.Fragment>
      ));
      if (node.bold) textFragments = textFragments.map((frag, index) => <strong key={index}>{frag}</strong>);
      if (node.italic) textFragments = textFragments.map((frag, index) => <em key={index}>{frag}</em>);
      if (node.underline) textFragments = textFragments.map((frag, index) => <u key={index}>{frag}</u>);
      return textFragments;
    case 'link':
      return <a href={node.url} key={node.url}>{node.children.map(renderNode)}</a>;
    case 'lineBreak':
      return <br key={node.key} />;
    default:
      return null;
  }
};

export const renderRichText = (richText) => {
  return richText.map((block, index) => {
    switch (block.type) {
      case 'paragraph':
        return <p key={index}>{block.children.map(renderNode)}</p>;
      case 'heading':
        switch (block.level) {
          case 1:
            return <h1 key={index}>{block.children.map(renderNode)}</h1>;
          case 2:
            return <h2 key={index}>{block.children.map(renderNode)}</h2>;
          case 3:
            return <h3 key={index}>{block.children.map(renderNode)}</h3>;
          case 4:
            return <h4 key={index}>{block.children.map(renderNode)}</h4>;
          case 5:
            return <h5 key={index}>{block.children.map(renderNode)}</h5>;
          case 6:
            return <h6 key={index}>{block.children.map(renderNode)}</h6>;
          default:
            return null;
        }
      default:
        return null;
    }
  });
};
